import styles from './IDCheck.module.css';
import { IDCheckCompleteIcon } from '../../../../components/svg/IDCheckCompleteIcon';
import { Button } from '../../../components/Button/Button';
import { Card } from '../../../components/Card/Card';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { useIsNonLinearFlow } from '../../hooks/useIsNonLinearFlow.hook';
import { useNavigateToBasePath } from '../../hooks/useNavigateToBasePath';
import { useNavigateToNextRequirement } from '../../hooks/useNavigateToNextRequirement';

export const IDCheckComplete = () => {
  const { nextRequirementName, goToNextRequirement } =
    useNavigateToNextRequirement();
  const { isNonLinearFlow } = useIsNonLinearFlow();
  const goToBasePath = useNavigateToBasePath();

  return (
    <Card title="">
      <div className={styles.checkCompleteScreen}>
        <h2 className={styles.checkCompleteLogo}>
          <IDCheckCompleteIcon className={styles.checkCompleteIcon} />
          ID Check complete
        </h2>
        <p className={styles.checkCompleteMessage}>
          Everything looks good, you can now continue.
        </p>
        <WhiteLabelOverride componentType="button" disabled={false}>
          <Button
            className={styles.checkCompleteButton}
            onClick={isNonLinearFlow ? goToBasePath : goToNextRequirement}
          >
            {isNonLinearFlow
              ? 'Continue'
              : `Continue to ${nextRequirementName}`}
          </Button>
        </WhiteLabelOverride>
      </div>
    </Card>
  );
};
